import React from "react";
import MissionComponent from "components/MissionComponent/MissionComponent";

export default function MissionPage() {
  return <MissionComponent />;
}
